import React from "react";
import SideBar from "./SideBar";
import StpSideBar from "../Stp/StpSideBar";

function Dashboard() {
  return (
    <>
      <div>
        <SideBar />
      </div>
      
    </>
  );
}

export default Dashboard;
